import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { generatePanelId } from "./panelsSlice.js";

const connectionEntity = createEntityAdapter({
    selectId: ({ hwaddr }) => hwaddr,
});

const entitySelectors = connectionEntity.getSelectors( state => state.connection);

export const connectionSlice = createSlice({
    name: "connection",
    initialState: connectionEntity.getInitialState(),

    reducers: {
        connected(state, action) {
            connectionEntity.upsertOne(state, {
                hwaddr: action.payload.hwaddr,
                connected: true,
            });
        },
        disconnected(state, action) {
            connectionEntity.upsertOne(state, {
                hwaddr: action.payload.hwaddr,
                connected: false,
            });
        },
    },
});

// actions

export const siteConnected = (hwaddr) => connectionSlice.actions.connected({ hwaddr });
export const siteDisconnected = (hwaddr) => connectionSlice.actions.disconnected({ hwaddr });


// Selectors

export const selectSiteConnected = (hwaddr) => state => {
    const rec = entitySelectors.selectById(state, hwaddr);
    if(rec)
    {
        return rec.connected;
    }
    return false;
}

export const useSiteConnected = (hwaddr) => useSelector(selectSiteConnected(hwaddr));

export default connectionSlice.reducer;
